/**
 * Checkout fallback for the AURA bundle accessory flow.
 *
 * When a bundle-capable product is in the cart, accessories are recommendable,
 * and the recommendation page has not been shown this session, the checkout
 * button on the cart page first sends the customer to the recommendation page.
 *
 * The cart drawer checkout button is intentionally not intercepted.
 *
 * Accelerated checkout wallets render outside the theme and are not covered.
 */
(function () {
  const SHOWN_KEY = 'aura_bundle_recommendation_shown';
  const STATE_SELECTOR = '.bundle-cart-state[data-bundle-has-candidates="true"]';

  document.addEventListener('click', onClick, true);
  document.addEventListener('submit', onSubmit, true);

  function onClick(event) {
    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkout || checkout.disabled || !isCartCheckout(checkout)) return;

    intercept(event);
  }

  function onSubmit(event) {
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout' || !isCartCheckout(submitter)) return;
    intercept(event);
  }

  /**
   * Only the cart page checkout button is covered; the cart drawer is left
   * alone. Product page Buy Now buttons also use name="checkout" and must
   * keep working.
   */
  function isCartCheckout(button) {
    return button.id === 'checkout';
  }

  function intercept(event) {
    const shown = recommendationShown();
    if (shown !== false) return; // shown, or storage unavailable -> do not block checkout

    const state = findState();
    const recommendUrl = state?.dataset.bundleRecommendUrl;
    if (!recommendUrl) return; // never block checkout without a destination

    event.preventDefault();
    event.stopImmediatePropagation();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'bundle_checkout_fallback',
      recommend_url: recommendUrl,
    });

    window.location.assign(recommendUrl);
  }

  /**
   * The cart page state is rendered inside #main-cart-items, which the cart
   * section rendering refreshes after line changes. The drawer state can be
   * stale on the cart page, so prefer the cart page state when it exists.
   */
  function findState() {
    return (
      document.querySelector(`#main-cart-items ${STATE_SELECTOR}`) ||
      document.querySelector(`cart-drawer ${STATE_SELECTOR}`) ||
      document.querySelector(`.cart-drawer ${STATE_SELECTOR}`) ||
      document.querySelector(STATE_SELECTOR)
    );
  }

  /**
   * Returns true/false when sessionStorage is usable, null when it is not.
   * A null result makes the guard fail open so checkout is never blocked by
   * a storage failure.
   */
  function recommendationShown() {
    try {
      const probe = '__bundle_storage_probe__';
      sessionStorage.setItem(probe, '1');
      sessionStorage.removeItem(probe);
      return sessionStorage.getItem(SHOWN_KEY) === '1';
    } catch (error) {
      return null;
    }
  }
})();
